import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { selectUser } from '../ngrx/data.reducer';
import { AccountType_v2 } from '../models/app-enums';

@Injectable({
  providedIn: 'root',
})
export class InnerGuard {

  userTypes = AccountType_v2;

  constructor(
    private router: Router,
    private store: Store,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    let userDetails: any;
    this.store
      .select(selectUser)
      .pipe(
        take(1),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((user) => {
        if (
          user &&
          (user?.userTypeId == this.userTypes.Both ||
            user?.userTypeId == this.userTypes.Fan ||
            user?.userTypeId == this.userTypes.Creator)
        ) {
          userDetails = user;
        }
      });

    if (userDetails) {
      var userType = userDetails?.userTypeId == this.userTypes.Creator ? 'creator' : 'fan';
      const routePath =
        '/' +
        userType +
        '/' +
        (userDetails?.userTypeId == this.userTypes.Creator
          ? 'dashboard'
          : 'chats');
      this.router.navigate([routePath]);
      return false;
    } else {
      return true;
    }
  }
}
